module.exports = __webpack_public_path__ + "static/media/edit.49d1e0dd.svg";